// extracted by mini-css-extract-plugin
module.exports = {"routing":"src-containers-Proposal-Detail-Routing-styles___routing","heading":"src-containers-Proposal-Detail-Routing-styles___heading"};